import types from './types'

export const mutations = {
  [types.SET_CUSTOMER] (state, customer) {
    state.customer = customer
  },

  [types.SET_PURCHASER] (state, purchaser) {
    state.purchaser = purchaser
  },
}
